interface AppConfig {
    APP_NAME: string;
    APP_ENVIRONMENT: string;
    GOOGLE_MAPS_API_KEY: string;
    GOOGLE_MAPS_MAP_ID: string;
    SENTRY_DSN: string;
    SENTRY_ENV: string;
    SENTRY_RELEASE: string;
    SIGNWELL_EMBEDDED_SCRIPT_URL: string;
    SIGNWELL_BATCH_THRESHOLD: number;
    REVERB_APP_KEY: string;
    REVERB_HOST: string;
    REVERB_PORT: number;
    REVERB_SCHEME: string;
    POSTHOG_ENABLED: boolean;
    POSTHOG_API_KEY: string;
    POSTHOG_HOST: string;
    POSTHOG_SESSION_RECORDING: boolean;
    POSTHOG_AUTOCAPTURE: boolean;
}

declare global {
    interface Window {
        __config__: AppConfig;
    }
}

const serverConfig = (typeof window !== 'undefined' && window.__config__) || ({} as Partial<AppConfig>);

const config = {
    APP_NAME: serverConfig.APP_NAME || 'Tourium',
    GOOGLE_MAPS_API_KEY: serverConfig.GOOGLE_MAPS_API_KEY || '',
    GOOGLE_MAPS_MAP_ID: serverConfig.GOOGLE_MAPS_MAP_ID || '',
    GOOGLE_ENDPOINT: 'https://maps.googleapis.com/maps/api/geocode/json',
    SENTRY_DSN: serverConfig.SENTRY_DSN || '',
    SENTRY_ENV: serverConfig.SENTRY_ENV || 'local',
    SENTRY_RELEASE: serverConfig.SENTRY_RELEASE || '',
    APP_ENVIRONMENT: serverConfig.APP_ENVIRONMENT || 'local',
    SIGNWELL_EMBEDDED_SCRIPT_URL: serverConfig.SIGNWELL_EMBEDDED_SCRIPT_URL || 'https://static.signwell.com/assets/embedded.js',
    SIGNWELL_BATCH_THRESHOLD: serverConfig.SIGNWELL_BATCH_THRESHOLD || 10,
    REVERB_APP_KEY: serverConfig.REVERB_APP_KEY || '',
    REVERB_HOST: serverConfig.REVERB_HOST || '',
    REVERB_PORT: serverConfig.REVERB_PORT || 443,
    REVERB_SCHEME: serverConfig.REVERB_SCHEME || 'https',
    POSTHOG_ENABLED: serverConfig.POSTHOG_ENABLED ?? true,
    POSTHOG_API_KEY: serverConfig.POSTHOG_API_KEY || '',
    POSTHOG_HOST: serverConfig.POSTHOG_HOST || 'https://us.i.posthog.com',
    POSTHOG_SESSION_RECORDING: serverConfig.POSTHOG_SESSION_RECORDING ?? true,
    POSTHOG_AUTOCAPTURE: serverConfig.POSTHOG_AUTOCAPTURE ?? true,
};

export default config;
